/*
 *
 * Home constants
 *
 */

export const HIDE_MODAL = 'app/components/Modal/ModalController/HIDE_MODAL';
export const SET_MODAL_OPTIONS = 'app/components/Modal/ModalController/SET_MODAL_OPTIONS';
export const SHOW_MODAL = 'app/components/Modal/ModalController/SHOW_MODAL';
export const MODAL_SENDING = 'app/components/Modal/ModalController/MODAL_SENDING';
